export default function TermsPage() {
    return (
        <section className="pv-lg center">
            <div className="m-auto" style={{width: '90%'}}>
                <h2 className="text-2xl lg:text-4xl mb-md">Términos y Condiciones de Uso</h2>
                <p className="text-gray-300">
                    Aquí van los términos y condiciones, incluyendo responsabilidades, licencias y regulaciones de los servicios.
                </p>
            </div>
        </section>
    );
}